export default {
    running: {
        type: 'success',
        message: window.i18n.__('Connecté'),
        color: 'green',
    },
    downloading: {
        type: 'success',
        message: window.i18n.__('En attente de synchronisation'),
        color: 'yellow',
    },
    initializing: {
        type: 'success',
        message: window.i18n.__('En attente de synchronisation'),
        color: 'yellow',
    },
    stopped: {
        type: 'success',
        message: window.i18n.__('En attente de synchronisation'),
        color: 'yellow',
    },
    'invalid-credentials': {
        type: 'warning',
        message: window.i18n.__("Echec d'authentification"),
        color: 'red',
    },
    cancelled: {
        type: 'warning',
        message: window.i18n.__('Annulé'),
        color: 'gray',
    },
    deleted: {
        type: 'warning',
        message: window.i18n.__('Annulé'),
        color: 'gray',
    },
    default: {
        type: 'error',
        message: window.i18n.__('Erreur de synchronisation'),
        color: 'red',
    },
};
